export { default as useUpdateIndexQueryItemsCache } from './useUpdateIndexQueryItemsCache';
